import { ReactComponent as DownloadIcon } from "../../../../assets/icons/download.svg";
import Button from "../../../../components/Button";

export const DownloadCSVButton = ({ onClick }) => (
  <Button testid="btn-download-csv" onClick={onClick}>
    Download
    <DownloadIcon />
  </Button>
);
